import React from 'react';
import PropTypes from 'prop-types';

import ImageGallery from 'react-image-gallery';

import { getOriginal, getThumbnail } from './mapImageToSrc';

import './ProductImageCarousel.css';

class ProductImageCarousel extends React.Component {
    constructor(props) {
        super(props);
        this.onImageIndexChanged = this.onImageIndexChanged.bind(this);
        this.imageIndexExists = this.imageIndexExists.bind(this);

        this.state = {
            hasCurrentImage: this.imageIndexExists(0)
        };
    }

    imageIndexExists(index) {
        return !!this.props.images.large && !!this.props.images.large[index] && !!this.props.images.large[index].Url;
    }

    onImageIndexChanged(index) {
        this.props.onImageIndexChanged(index);
        this.setState({ hasCurrentImage: this.imageIndexExists(index) });
    }

    render() {
        const { images, onShowBigger } = this.props;
        const originalAndThumbnailItems = images.large.map((image) => ({
            original: getOriginal(image),
            thumbnail: getThumbnail(image)
        }));
        return (
            <div className='product-details-left product-carousel'>
                <ImageGallery
                    ref={i => this._imageGallery = i}
                    items={originalAndThumbnailItems}
                    showPlayButton={false}
                    showThumbnails
                    thumbnailPosition={"left"}
                    showNav={false}
                    showFullscreenButton={false}
                    onSlide={this.onImageIndexChanged}
                    startIndex={this.props.currentIndex}
                />
                {this.state.hasCurrentImage && (
                    <div className='image-big-view text-center'>
                        <a
                            href=""
                            className="biggerImage"
                            onClick={e => {
                                e.preventDefault();
                                onShowBigger();
                            }}
                        >
                            <span className="fa fa-search-plus" /> {'Click here to view larger image'}
                        </a>
                    </div>
                )}
            </div>
        );
    }
}

ProductImageCarousel.propTypes = {
    images: PropTypes.shape({
        large: PropTypes.array.isRequired
    }),
    onImageIndexChanged: PropTypes.func,
    onShowBigger: PropTypes.func
};

export default ProductImageCarousel;


